import { useSelector } from 'react-redux';
import { GuidedProcessSupportProps } from '../../pages/arc/models/arc-epi-props';
import { TcsmStates } from '../../root/tcsm-model';
import { GpsType } from '../components/layout/layout-models';
import { DemographicAppKeys } from '../models/demographics-model';


export function useGpsType(type: GpsType, app?: DemographicAppKeys) {
    const gpsState = useSelector<TcsmStates, GuidedProcessSupportProps>(state => state.epiProps?.gpsSettingsState?.epiContent);
    let contents = null;
    let title = null;
    if (gpsState) {

        switch (type) {
            case GpsType.DEMOGRAPHIC:
                contents = app === DemographicAppKeys.arc ? gpsState.demographicSectionArea : gpsState.myCpgDemographicSectionArea;
                title = app === DemographicAppKeys.arc ? gpsState.guidedSupportSectionTitle : gpsState.myCpgDemographicTitle;
                break;

            case GpsType.MARITAL_STATUS:
                contents = app === DemographicAppKeys.arc ? gpsState.maritalStatusSectionArea : gpsState.myCpgMaritalStatusSectionArea;
                title = app === DemographicAppKeys.arc ? gpsState.guidedSupportMaritalStatusTitle : gpsState.myCpgGuidedSupportMaritalStatusTitle;
                break;
            case GpsType.ADD_DEPENDENT:

                contents = app === DemographicAppKeys.arc ? gpsState.addDependentSectionArea : gpsState.myCpgAddDependentSectionArea;
                title = app === DemographicAppKeys.arc ? gpsState.addDependentSectionTitle : gpsState.myCpgAddDependentSectionTitle;
                break;
            case GpsType.EDIT_DEPENDENT:
                contents = app === DemographicAppKeys.arc ? gpsState.editDependentSectionArea : gpsState.myCpgEditDependentSectionArea;
                title = app === DemographicAppKeys.arc ? gpsState.editDependentSectionTitle : gpsState.myCpgEditDependentSectionTitle;
                break;
            case GpsType.RELATIONSHIP:

                contents = app === DemographicAppKeys.arc ? gpsState.relationshipSectionArea : gpsState.myCpgRelationshipSectionArea;
                title = app === DemographicAppKeys.arc ? gpsState.relationshipSectionTitle : gpsState.myCpgRelationshipSectionTitle;
                break;

            case GpsType.DOMESTIC_PARTNER:

                contents = gpsState.myCpgDomesticPartnerSectionArea;
                title = gpsState.myCpgDomesticPartnerSectionTitle;
                break;
            case GpsType.AE_DEMOGRAPHIC:

                contents = app === DemographicAppKeys.arc ? gpsState.aeMapDemographicSectionArea : gpsState.aeMyCpgDemographicSectionArea;
                title = app === DemographicAppKeys.arc ? gpsState.aeMapDemographicTitle : gpsState.aeMyCpgDemographicTitle;
                break;

            case GpsType.AE_MARITAL_STATUS:

                contents = app === DemographicAppKeys.arc ? gpsState.aeMapMaritalStatusSectionArea : gpsState.aeMyCpgMaritalStatusSectionArea;
                title = app === DemographicAppKeys.arc ? gpsState.aeMapGuidedSupportMaritalStatusTitle : gpsState.aeMyCpgGuidedSupportMaritalStatusTitle;
                break;
            case GpsType.AE_DEPENDENT:

                contents = app === DemographicAppKeys.arc ? gpsState.aeMapDependentSectionArea : gpsState.aeMyCpgDependentSectionArea;
                title = app === DemographicAppKeys.arc ? gpsState.aeMapDependentSectionTitle : gpsState.aeMyCpgDependentSectionTitle;
                break;
            case GpsType.AE_RELATIONSHIP:

                contents = app === DemographicAppKeys.arc ? gpsState.aeMapRelationshipSectionArea : gpsState.aeMyCpgRelationshipSectionArea;
                title = app === DemographicAppKeys.arc ? gpsState.aeMapRelationshipSectionTitle : gpsState.aeMyCpgRelationshipSectionTitle;
                break;
            case GpsType.COMPENSATION:

                contents = gpsState.compensationSectionArea;
                title = gpsState.compensationSectionTitle;
                break;
            case GpsType.EMPLOYMENT:

                contents = gpsState.employmentSectionArea;
                title = gpsState.employmentSectionTitle;
                break;
            case GpsType.UPDATE_SCHEDULED_HOUR:

                contents = gpsState.scheduledHourSectionArea;
                title = gpsState.scheduledHourSectionTitle;
                break;
            case GpsType.SCHEDULED_HOUR_HISTORY:

                contents = gpsState.scheduledHourHistorySectionArea;
                title = gpsState.scheduledHourHistorySectionTitle;
                break;
            case GpsType.SCHEDULED_PAYMENT:

                contents = gpsState.updateScheduledPaymentSectionArea;
                title = gpsState.updateScheduledPaymentSectionTitle;
                break;
            case GpsType.ONE_TIME_PAYMENT:

                contents = gpsState.oneTimePaymentSectionArea;
                title = gpsState.oneTimePaymentSectionTitle;
                break;
            case GpsType.COMPENSATION_HISTORY:
                contents = gpsState.compensationHistorySectionArea;
                title = gpsState.compensationHistorySectionTitle;
                break;
            case GpsType.UPDATE_STIPE:

                contents = gpsState.updateStipeSectionArea;
                title = gpsState.updateStipePositionSectionTitle;
                break;
            case GpsType.EDIT_STIPE:

                contents = gpsState.editStipeSectionArea;
                title = gpsState.editStipeSectionTitle;
                break;
            case GpsType.ADD_NONSTIPE:

                contents = gpsState.addNonStipeSectionArea;
                title = gpsState.addNonStipeSectionTitle;
                break;
            case GpsType.EDIT_NONSTIPE:

                contents = gpsState.nonStipeSectionArea;
                title = gpsState.nonStipeSectionTitle;
                break;
            case GpsType.EMPLOYEE_LIST:

                contents = gpsState.employeeListSectionArea;
                title = gpsState.employeeListSectionTitle;
                break;
            case GpsType.INSTITUTION_LIST:

                contents = gpsState.institutionListSectionArea;
                title = gpsState.institutionListTitle;
                break;
            case GpsType.INSTITUTION_DETAIL:

                contents = gpsState.institutionDetailSectionArea;
                title = gpsState.institutionDetailSectionTitle;
                break;
            case GpsType.INSTITUTION_SURVEY:

                contents = gpsState.institutionDemoSectionArea;
                title = gpsState.institutionDemoSectionTitle;
                break;
            case GpsType.INSTITUTION_ADD_REQUEST:
                contents = gpsState.institutionAddRequestSectionArea;
                title = gpsState.institutionAddRequestTitle;

                break;
            case GpsType.INSTITUTION_ADD_REQUEST_SUBMITTED:
                contents = gpsState.institutionAddRequestSubmittedSectionArea;
                title = gpsState.institutionAddRequestSubmittedTitle;

                break;
            case GpsType.INSTITUTION_REMOVE_REQUEST:
                contents = gpsState.institutionRemoveRequestSectionArea;
                title = gpsState.institutionRemoveRequestTitle;

                break;
            case GpsType.INSTITUTION_REMOVE_REQUEST_SUBMITTED:
                contents = gpsState.institutionRemoveRequestSubmittedSectionArea;
                title = gpsState.institutionRemoveRequestSubmittedTitle;

                break;
            case GpsType.PLAN_SUMMARY:

                contents = gpsState.planSummarySectionArea;
                title = gpsState.planSummarySectionTitle;
                break;
            case GpsType.INSTITUTION_ADMINISTRATOR:

                contents = gpsState.addOfficerSectionArea;
                title = gpsState.addOfficerSectionTitle;
                break;

            case GpsType.ADD_INSTITUTION_ADMINISTRATOR_CONFIRMATION:
                contents = gpsState.addOfficerConfrimationSectionArea;
                title = gpsState.addOfficerConfrimationSectionTitle;
                break;

            case GpsType.ADD_INSTITUTION_ADMINISTRATOR_REVIEW:
                contents = gpsState.addOfficerReviewSectionArea;
                title = gpsState.addOfficerReviewSectionTitle;
                break;

            case GpsType.GROUP_LIST:

                contents = gpsState.groupListSectionArea;
                title = gpsState.groupListSectionTitle;
                break;
            case GpsType.BILLING_ACCOUNT:

                contents = gpsState.billingAccountsSectionArea;
                title = gpsState.billingAccountsSectionTitle;
                break;
            case GpsType.PARTICIPANT:

                contents = gpsState.participantListSectionArea;
                title = gpsState.participantListSectionTitle;
                break;

            case GpsType.GROUP_ADMIN_LIST:

                contents = gpsState.groupAdminSectionArea;
                title = gpsState.groupAdminSectionTitle;
                break;

            case GpsType.ADD_ADMIN:
                contents = gpsState.addAdminSectionArea;
                title = gpsState.addAdminSectionTitle;
                break;

            case GpsType.ADD_ADMIN_CONFIRMATION:
                contents = gpsState.addAdminConfrimationSectionArea;
                title = gpsState.addAdminConfrimationSectionTitle;
                break;

            case GpsType.ADD_ADMIN_REVIEW:
                contents = gpsState.addAdminReviewSectionArea;
                title = gpsState.addAdminReviewSectionTitle;
                break;

            case GpsType.DOWNLOADS:

                contents = gpsState.downloadSectionArea;
                title = gpsState.downloadSectionTitle;
                break;
            case GpsType.AE_COVERAGE:

                contents = app === DemographicAppKeys.arc ? gpsState.aeMapCoverageSectionArea : gpsState.aeMyCpgCoverageSectionArea;
                title = app === DemographicAppKeys.arc ? gpsState.aeMapCoverageSectionTitle : gpsState.aeMyCpgCoverageSectionTitle;
                break;
            case GpsType.AE_REVIEW:

                contents = app === DemographicAppKeys.arc ? gpsState.aeMapReviewSectionArea : gpsState.aeMyCpgReviewSectionArea;
                title = app === DemographicAppKeys.arc ? gpsState.aeMapReviewSectionTitle : gpsState.aeMyCpgReviewSectionTitle;
                break;
            case GpsType.AE_CONFIRMTION:

                contents = app === DemographicAppKeys.arc ? gpsState.aeMapConfirmationSectionArea : gpsState.aeMyCpgConfirmationSectionArea;
                title = app === DemographicAppKeys.arc ? gpsState.aeMapConfirmationSectionTitle : gpsState.aeMyCpgConfirmationSectionTitle;
                break;
            case GpsType.AE_INTERRUPT:

                contents = gpsState.aeMapInterruptSectionArea;
                title = gpsState.aeMapInterruptSectionTitle;
                break;
            case GpsType.AE_IN_PROGRESS:

                contents = gpsState.aeMapSubmittedSectionArea;
                title = gpsState.aeMapSubmittedSectionTitle;
                break;
            case GpsType.MID_YEAR_COVERAGE:

                contents = gpsState.midYearCoverageSectionArea;
                title = gpsState.midYearCoverageSectionTitle;
                break;
            case GpsType.MID_YEAR_IN_HELD:

                contents = gpsState.midYearInHeldSectionArea;
                title = gpsState.midYearInHeldSectionTitle;
                break;

            case GpsType.MID_YEAR_WELCOME_PAGE:

                contents = gpsState.myCpgMidYearWelcomePageGuidedProcessSupport;
                title = gpsState.myCpgMidYearWelcomePageSectionTitle;
                break;

            case GpsType.MID_YEAR_IN_PROGRESS:

                contents = gpsState.midYearInProgressSectionArea;
                title = gpsState.midYearInProgressSectionTitle;
                break;
            case GpsType.ALERT_NOTIFICATION:

                contents = gpsState.alertAndNotificationSectionArea;
                title = gpsState.alertAndNotificationSectionTitle;
                break;
            case GpsType.NEW_HIRE_DEMO:

                contents = gpsState.newHireDemoSectionArea;
                title = gpsState.newHireDemoSectionTitle;
                break;
            case GpsType.NEW_HIRE_STIP:

                contents = gpsState.newHireStipendiarySectionArea;
                title = gpsState.newHireStipendiarySectionTitle;
                break;
            case GpsType.NEW_HIRE_NON_STIP:

                contents = gpsState.newHireNonStipSectionArea;
                title = gpsState.newHireNonStipSectionTitle;
                break;
            case GpsType.NEW_HIRE_SEARCH_INSIDE:

                contents = gpsState.newHireSearchInsideSectionArea;
                title = gpsState.newHireSearchInsideSectionTitle;
                break;
            case GpsType.NEW_HIRE_SEARCH_OUTSIDE:

                contents = gpsState.newHireSearchOutSideSectionArea;
                title = gpsState.newHireSearchOutsideSectionTitle;
                break;
            case GpsType.NEW_HIRE_NON_STIP_CONFIRMATION:

                contents = gpsState.newHireNonStipConfirmationSectionArea;
                title = gpsState.newHireNonStipConfirmationSectionTitle;
                break;
            case GpsType.NEW_HIRE_STIP_CONFIRMATION:

                contents = gpsState.newHireStipConfirmationSectionArea;
                title = gpsState.newHireStipConfirmationSectionTitle;
                break;
            case GpsType.PENSION_ENROLLMENT:
                title = gpsState.pensionEnrollmentSectionTitle;
                contents = gpsState.pensionEnrollmentSectionArea;
                break;
            case GpsType.TERMINATION_FORM:
                title = gpsState.terminationFormSectionTitle;
                contents = gpsState.terminationFormSectionArea;
                break;
            case GpsType.TERMINATION_CONFIRMATION_STIP_NONSTIP:
                title = gpsState.stipNonStipTerminationConfirmationSectionTitle;
                contents = gpsState.stipNonStipTerminationConfirmationSectionArea;
                break;
            case GpsType.TERMINATION_CONFIRMATION_STIP:
                title = gpsState.stipTerminationConfirmationSectionTitle;
                contents = gpsState.stipTerminationConfirmationSectionArea;
                break;
            case GpsType.TERMINATION_CONFIRMATION_NONSTIP:
                title = gpsState.nonStipTerminationConfirmationSectionTitle;
                contents = gpsState.nonStipTerminationConfirmationSectionArea;
                break;
            case GpsType.TERMINATION_CONFIRMATION_DEATH:
                title = gpsState.deathTerminationConfirmationSectionTitle;
                contents = gpsState.deathTerminationConfirmationSectionArea;
                break;
            case GpsType.TERMINATION_CONFIRMATION_NEVER_WORKED_HERE:
                title = gpsState.neverWorkedHereTerminationConfirmationSectionTitle;
                contents = gpsState.neverWorkedHereTerminationConfirmationSectionArea;
                break;

            case GpsType.DIOCESE_LIST:
                title = gpsState.dioceseSearchGpsTitle;
                contents = gpsState.dioceseSearchGps;
                break;

            case GpsType.EMPLOYMENT_COMPENSATION:
                title = gpsState.employmentCompensationTitle;
                contents = gpsState.employmentCompensationGps;
                break;

            case GpsType.LOA_FORM:
                title = gpsState.loaGpsTitle;
                contents = gpsState.loaGps;
                break;

            case GpsType.AE_HELD:
                contents = gpsState.aeHeldSectionArea;
                title = gpsState.aeHeldSectionTitle;
                break;

            case GpsType.AE_ADMIN_HELD:
                contents = gpsState.aeMapHeldSectionArea;
                title = gpsState.aeMapHeldSectionTitle;
                break;

            case GpsType.NEW_HIRE_EMPLOYMENT:
                contents = gpsState.newHireSearchNonStipeEmploymentTypeSectionArea;
                title = gpsState.newHireSearchNonStipeEmploymentTypeTitle;
                break;

            case GpsType.NEW_HIRE_CLERGY_TYPE:
                contents = gpsState.newHireClergyTypeSectionArea;
                title = gpsState.newHireClergyTypeTitle;
                break;

            case GpsType.NEW_HIRE_RETIREMENT:
                contents = gpsState.newHireRetirementSectionArea;
                title = gpsState.newHireRetirementTitle;
                break;

            case GpsType.EMPLOYMENT_HISTORY:
                title = gpsState.employmentHistoryTitle;
                contents = gpsState.employmentHistoryGps;
                break;

            case GpsType.NEW_PARTICIPANT_WHO_WILL_ENROLL:
                title = gpsState.participantWhoWillEnrollTitle;
                contents = gpsState.participantWhoWillEnrollGps;
                break;

            case GpsType.NEW_PARTICIPANT_BENEFIT_PERSON_INFO:
                title = gpsState.participantPersonalInfoTitle;
                contents = gpsState.participantPersonalInfoGps;
                break;

            case GpsType.NEW_PARTICIPANT_RELATIONSHIP:
                title = gpsState.participantRelationshipTitle;
                contents = gpsState.participantRelationshipGps;
                break;

            case GpsType.NEW_PARTICIPANT_COVERAGE:
                title = gpsState.participantCoverageTitle;
                contents = gpsState.participantCoverageGps;
                break;


            case GpsType.NEW_PARTICIPANT_COVERAGE_REVIEW:
                title = gpsState.participantCoverageReviewTitle;
                contents = gpsState.participantCoverageReviewGps;
                break;

            case GpsType.NEW_PARTICIPANT_RETIREMENT:
                title = gpsState.participantRetirementTitle;
                contents = gpsState.participantRetirementGps;
                break;

            case GpsType.BENEFICIARY_LANDINGPAGE:
                title = gpsState.beneficiaryLandingTitle;
                contents = gpsState.beneficiaryLandingGps;
                break;

            case GpsType.BENEFICIARY_UPDATE:
                title = gpsState.beneficiaryUpdateTitle;
                contents = gpsState.beneficiaryUpdateGps;
                break;

            case GpsType.NEW_HIRE_RETIREMENT_ADMIN:
                title = gpsState.newHireRetirementAdminTitle;
                contents = gpsState.newHireRetirementAdminGps;
                break;


            case GpsType.BENEFICIARY_CREATE:
                title = gpsState.beneficiaryCreateTitle;
                contents = gpsState.beneficiaryCreateGps;
                break;

            case GpsType.NEW_HIRE_WHO_WILL_ENROLL:
                title = gpsState.newHireWhoWillEnrollTitle;
                contents = gpsState.newHireWhoWillEnrollGps;
                break;

            case GpsType.NEW_HIRE_PERSONAL_INFO:
                title = gpsState.newHirePersonInfoTitle;
                contents = gpsState.newHirePersonInfoGps;
                break;

            case GpsType.NEW_HIRE_RELATIONSHIP:
                title = gpsState.newHireRelationshipTitle;
                contents = gpsState.newHireRelationshipGps;
                break;

            case GpsType.NEW_HIRE_MARITAL_STATUS:
                title = gpsState.newHireMaritalStatusTitle;
                contents = gpsState.newHireMaritalStatusGps;
                break;

            case GpsType.NEW_HIRE_DEPENDENT:
                title = gpsState.newHireDependentTitle;
                contents = gpsState.newHireDependentGps;
                break;

            case GpsType.NEW_HIRE_COVERAGE_ADMIN:
                title = gpsState.newHireCoverageAdminTitle;
                contents = gpsState.newHireCoverageAdminGps;
                break;

            case GpsType.NEW_HIRE_REVIEW_ADMIN:
                title = gpsState.newHireReviewAdminTitle;
                contents = gpsState.newHireReviewAdminGps;
                break;
            case GpsType.NEW_HIRE_COVERAGE_DIO_APPROVER:
                title = gpsState.dioceseApproverCoveragePageGuidedProcessSupportTitle;
                contents = gpsState.dioceseApproverCoveragePageGuidedProcessSupport;
                break;

            case GpsType.NEW_HIRE_REVIEW_DIO_APPROVER:
                title = gpsState.dioceseApproverCoverageReviewPageGuidedProcessSupportTitle;
                contents = gpsState.dioceseApproverCoverageReviewPageGuidedProcessSupport;
                break;
            case GpsType.MEMBER_NEW_HIRE_PERSON_INFO:
                title = gpsState.memberNewHirePersonInfoTitle;
                contents = gpsState.memberNewHirePersonInfoGps;
                break;
            case GpsType.MEMBER_NEW_HIRE_RELATIONSHIP:
                title = gpsState.memberNewHireRelationshipTitle;
                contents = gpsState.memberNewHireRelationshipGps;
                break;
            case GpsType.MEMBER_NEW_HIRE_EMPLOYMENT:
                title = gpsState.memberNewHireEmploymentTitle;
                contents = gpsState.memberNewHireEmploymentGps;
                break;
            case GpsType.MEMBER_NEW_HIRE_MARITAL_STATUS:
                title = gpsState.memberNewHireMaritalStatusTitle;
                contents = gpsState.memberNewHireMaritalStatusGps;
                break;
            case GpsType.MEMBER_NEW_HIRE_DEPENDENT:
                title = gpsState.memberNewHireDependentTitle;
                contents = gpsState.memberNewHireDependentGps;
                break;
            case GpsType.MEMBER_NEW_HIRE_COVERAGE:
                title = gpsState.memberNewHireCoverageTitle;
                contents = gpsState.memberNewHireCoverageGps;
                break;
            case GpsType.MEMBER_NEW_HIRE_REVIEW:
                title = gpsState.memberNewHireReviewTitle;
                contents = gpsState.memberNewHireReviewGps;
                break;

            case GpsType.MEMBER_NEW_HIRE_RETIREMENT_PLAN:
                title = gpsState.memberNewHireRetirementTitle;
                contents = gpsState.memberNewHireRetirementGps;
                break;
            case GpsType.NEW_HIRE_BY_DIO_CONFIRMATION:
                title = gpsState.newHireByDioConfirmationTitle;
                contents = gpsState.newHireByDioConfirmationGps;
                break;
            case GpsType.NEW_HIRE_BY_MEMBER_CONFIRMATION:
                title = gpsState.newHireByMemberConfirmationTitle;
                contents = gpsState.newHireByMemberConfirmationGps;
                break;

            case GpsType.INSTITUTION_ADMIN_CONFIRMATION_PENDING_APPROVAL:
                title = gpsState.institutionAdminPendingApprovalGpsTitle;
                contents = gpsState.institutionAdminPendingApprovalGps;
                break;

            case GpsType.NEW_HIRE_CONFIRMATION_DIO_APPROVER_APPROVE:
                title = gpsState.dioceseApproverConfirmationApprovePageGuidedProcessSupportTitle;
                contents = gpsState.dioceseApproverConfirmationApprovePageGuidedProcessSupport;
                break;

            case GpsType.NEW_HIRE_CONFIRMATION_DIO_APPROVER_REJECT:
                title = gpsState.dioceseApproverConfirmationRejectPageGuidedProcessSupportTitle;
                contents = gpsState.dioceseApproverConfirmationRejectPageGuidedProcessSupport;
                break;

            case GpsType.CREATE_NEW_PARTICIPANT:
                title = gpsState.createNewParticipantTitle;
                contents = gpsState.createNewParticipantGps;
                break;

            case GpsType.NEW_PARTICIPANT_CONFIRMATION:
                title = gpsState.participantConfirmationTitle;
                contents = gpsState.participantConfirmationGps;
                break;

            case GpsType.MYCPG_MIDYEAR_PERSONALINFO:
                title = gpsState.myCpgMidYearPersonalInfoSectionTitle;
                contents = gpsState.myCpgMidYearPersonalInfoSectionArea;
                break;

            case GpsType.MYCPG_MIDYEAR_MARITAL_STATUS:
                title = gpsState.myCpgMidYearMaritalStatusSectionTitle;
                contents = gpsState.myCpgMidYearMaritalStatusSectionArea;
                break;

            case GpsType.MYCPG_MIDYEAR_RELATIONSHIP:
                title = gpsState.myCpgMidYearRelationshipSectionTitle;
                contents = gpsState.myCpgMidYearRelationshipSectionArea;
                break;

            case GpsType.MYCPG_MIDYEAR_DEPENDENT:
                title = gpsState.myCpgMidYearDependentSectionTitle;
                contents = gpsState.myCpgMidYearDependentSectionArea;
                break;

            case GpsType.MYCPG_MIDYEAR_COVERAGE:
                title = gpsState.myCpgMidYearCoverageSectionTitle;
                contents = gpsState.myCpgMidYearCoverageSectionArea;
                break;

            case GpsType.MYCPG_MIDYEAR_REVIEW:
                title = gpsState.myCpgMidYearReviewSectionTitle;
                contents = gpsState.myCpgMidYearReviewSectionArea;
                break;
            case GpsType.MYCPG_MIDYEAR_CONFIRMATION_MARRIAGE:
                title = gpsState.myCpgMidYearConfirmationMarriageGPSTitle;
                contents = gpsState.myCpgMidYearConfirmationMarriageGPSSectionArea;
                break;
            case GpsType.MYCPG_MIDYEAR_CONFIRMATION_LEGAL_SEPARATION:
                title = gpsState.myCpgMidYearConfirmationLegalSeparationGPSTitle;
                contents = gpsState.myCpgMidYearConfirmationLegalSeparationGPSSectionArea;
                break;
            case GpsType.MYCPG_MIDYEAR_CONFIRMATION_DOMESTIC_PARTNERSHIP:
                title = gpsState.myCpgMidYearConfirmationDomesticPartnershipGPSTitle;
                contents = gpsState.myCpgMidYearConfirmationDomesticPartnershipGPSSectionArea;
                break;
            case GpsType.MYCPG_MIDYEAR_CONFIRMATION_DISSOLUTION_DOMESTIC_PARTNERSHIP:
                title = gpsState.myCpgMidYearConfirmationDissolutionDomesticPartnershipGPSTitle;
                contents = gpsState.myCpgMidYearConfirmationDissolutionDomesticPartnershipEndGPSSectionArea;
                break;

            case GpsType.MYCPG_MIDYEAR_CONFIRMATION_LIFE_EVENT:
                title = gpsState.myCpgMidYearConfirmationLifeEventGPSTitle;
                contents = gpsState.myCpgMidYearConfirmationConfirmationLifeEventGPSSectionArea;
                break;
            case GpsType.MYCPG_MIDYEAR_CONFIRMATION_ADDING_CHILDREN:
                title = gpsState.myCpgMidYearAddingChildrenConfirmationGPSTitle;
                contents = gpsState.myCpgMidYearAddingChildrenConfirmationGPSSectionArea;
                break;
            case GpsType.MYCPG_MIDYEAR_CONFIRMATION_DIVORCE:
                title = gpsState.myCpgMidYearDivorceConfirmationGPSTitle;
                contents = gpsState.myCpgMidYearDivorceConfirmationGPSSectionArea;
                break;
            case GpsType.MYCPG_MIDYEAR_DIO_APPROVER_COVERAGE:
                title = gpsState.myCpgMidYearDioApproverCoverageGPSTitle;
                contents = gpsState.myCpgMidYearDioApproverCoverageGPSSectionArea;
                break;

            case GpsType.MYCPG_MIDYEAR_DIO_APPROVER_REVIEW:
                title = gpsState.myCpgMidYearDioApproverReviewGPSTitle;
                contents = gpsState.myCpgMidYearDioApproverReviewGPSSectionArea;
                break;

            case GpsType.DependentGainingHealth:
                title = gpsState.myCpgDependentGainingHealthBenefitsSectionTitle;
                contents = gpsState.myCpgDependentGainingHealthBenefitsSectionArea;
                break;
            case GpsType.ChangeInDomesticOrSpouse:
                title = gpsState.myCpgMidYearChangeInSpouseOrDomesticPartnerSectionTitle;
                contents = gpsState.myCpgChangeInSpouseOrDomesticPartnerSectionArea;
                break;
            case GpsType.LossOfCoverage:
                title = gpsState.myCpgLossOfCoverageSectionTitle;
                contents = gpsState.myCpgLossOfCoverageSectionArea;
                break;
            case GpsType.SignificantChangeInCostOrCurtailment:
                title = gpsState.myCpgSignificantChangeInMedicalSectionTitle;
                contents = gpsState.myCpgSignificantChangeInMedicalSectionArea;
                break;
            case GpsType.LayDbAdoption:
                title = gpsState.adoptLayDbGpsTitle;
                contents = gpsState.adoptLayDbGps;
                break;

            case GpsType.LayDcAdoptionDetail:
                title = gpsState.layDcAdoptionDetailTitle;
                contents = gpsState.layDcAdoptionDetailSectionArea;
                break;

            case GpsType.LayDcAdoptionQuestions:
                title = gpsState.layDcAdoptionQuestionsTitle;
                contents = gpsState.layDcAdoptionQuestionsSectionArea;
                break;

            case GpsType.LayDcAdoptionReview:
                title = gpsState.layDcAdoptionReviewTitle;
                contents = gpsState.layDcAdoptionReviewSectionArea;
                break;

            case GpsType.LayDcAdoptionIndemnify:
                title = gpsState.layDcAdoptionIndemnifyTitle;
                contents = gpsState.layDcAdoptionIndemnifySectionArea;
                break;

            case GpsType.RsvpAdoptionDetail:
                title = gpsState.rsvpAdoptionDetailTitle;
                contents = gpsState.rsvpAdoptionDetailSectionArea;
                break;

            case GpsType.RsvpAdoptionQuestions:
                title = gpsState.rsvpAdoptionQuestionsTitle;
                contents = gpsState.rsvpAdoptionQuestionsSectionArea;
                break;

            case GpsType.RsvpAdoptionReview:
                title = gpsState.rsvpAdoptionReviewTitle;
                contents = gpsState.rsvpAdoptionReviewSectionArea;
                break;

            case GpsType.RsvpAdoptionIndemnify:
                title = gpsState.rsvpAdoptionIndemnifyTitle;
                contents = gpsState.rsvpAdoptionIndemnifySectionArea;
                break;

            case GpsType.LayDcAmendQuestions:
                title = gpsState.layDcAmendQuestionsTitle;
                contents = gpsState.layDcAmendQuestionsSectionArea;
                break;

            case GpsType.LayDcAmendReview:
                title = gpsState.layDcAmendReviewTitle;
                contents = gpsState.layDcAmendReviewSectionArea;
                break;

            case GpsType.LayDcAmendDetail:
                title = gpsState.layDcAmendPlanDetailTitle;
                contents = gpsState.layDcAmendPlanDetailSectionArea;
                break;

            case GpsType.LayDcAmendIndemnify:
                title = gpsState.layDcAmendIndemnifyTitle;
                contents = gpsState.layDcAmendIndemnifySectionArea;
                break;

            case GpsType.RsvpAmendDetail:
                title = gpsState.rsvpAmendDetailTitle;
                contents = gpsState.rsvpAmendDetailSectionArea;
                break;

            case GpsType.RsvpAmendQuestions:
                title = gpsState.rsvpAmendQuestionsTitle;
                contents = gpsState.rsvpAmendQuestionsSectionArea;
                break;

            case GpsType.RsvpAmendReview:
                title = gpsState.rsvpAmendReviewTitle;
                contents = gpsState.rsvpAmendReviewSectionArea;
                break;

            case GpsType.RsvpAmendIndemnify:
                title = gpsState.rsvpAmendIndemnifyTitle;
                contents = gpsState.rsvpAmendIndemnifySectionArea;
                break;

            case GpsType.DeclineMedicalDental:
                title = gpsState.declineMedicalDentalTitle;
                contents = gpsState.declineMedicalDentalSectionArea;
                break;

			case GpsType.DEATH_OF_CHILD:
				title = gpsState.deathOfChildLifeEventGpsTitle;
				contents = gpsState.deathOfChildLifeEventGpsSectionArea;
				break;
			case GpsType.JUDGEMENT_DECREE_ORDER:
				title = gpsState.judgementDecreeGpsTitle;
				contents = gpsState.judgementDecreeGpsContentArea;
				break;
			case GpsType.LIFE_EVENTS_LANDING:
				title = gpsState.lifeEventsLandingTitle;
				contents = gpsState.lifeEventsLandingContentArea;
				break;

			case GpsType.MIDYEAR_CONFIRMATION_HOURS_INCREASE:
				title = gpsState.mapMidyearHoursIncreaseConfirmationSectionTitle;
				contents = gpsState.mapMidyearHoursIncreaseConfirmationSectionArea;
				break;

			case GpsType.SCHEDULED_HOUR_WHO_WILL_ENROLL:
				title = gpsState.scheduledHourWhoWillEnrollSectionTitle;
				contents = gpsState.scheduledHourWhoWillEnrollSectionArea;
				break;

            case GpsType.CIC_OPT_IN_FORM:
                title = gpsState.cicFormGpsTitle;
                contents = gpsState.cicFormGps;
                break;

            case GpsType.MYCPG_BILLING:
                title = gpsState.mycpgBillingTitle;
                contents = gpsState.mycpgBillingSectionArea;
                break;
            

			default:
				break;
		}
	}

    return { title, contents };

}

